import authConfig from './authConfig';

/**
 * MSAL Configuration for Azure AD Authentication
 *
 * Uses values from authConfig.js and dynamically determines redirect URIs
 * based on the current window location.
 *
 * Documentation: https://learn.microsoft.com/en-us/entra/msal/javascript/browser/initialization
 */

// Get the current origin (e.g., http://localhost:8080 or https://somedomain.bluefletch.com)
const currentOrigin = window.location.origin;
const authEnvConfig = authConfig[process.env.REACT_APP_ENTRA_ENVIRONMENT];

const msalConfig = {
  auth: {
    clientId: authEnvConfig.client_id, // Application (client) ID from authConfig
    authority: authEnvConfig.authority, // Tenant ID from authConfig
    redirectUri: `${currentOrigin}/callback`, // Dynamic callback URI
    postLogoutRedirectUri: currentOrigin, // Dynamic logout redirect URI
    navigateToLoginRequestUrl: false, // Set to false to stay on the callback page
  },
  cache: {
    cacheLocation: 'sessionStorage', // Options: 'sessionStorage' or 'localStorage'
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            console.warn(message);
            return;
          case 2: // LogLevel.Info
            console.info(message);
            return;
          case 3: // LogLevel.Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes requested during login
 * Uses scope from authConfig and converts it to an array
 */
const loginRequest = {
  scopes: authEnvConfig.scope ? authEnvConfig.scope.trim().split(/\s+/) : ['openid', 'profile', 'email', 'offline_access'],
  prompt: 'login', // Force interactive login every time, don't use cached credentials
};

export { msalConfig, loginRequest };
